import React from 'react';
import Pro01 from "../../images/services/ls/Experimentation-Over-Elaborate-Planning.webp";
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Agile(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container classNanme="h-100">
                <Row classNanme="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
                        <div className="example" data-text="Experimentation">
                            <h2>Experimentation Over Elaborate Planning</h2>
                        </div>
                        <p>TekRevol relies on modern methodologies, including agile, to stay a step ahead of the market. Our lean startup services develop digital products in record time, with features that define your success. We divide the project into multiple phases and improve as we move forward with the development. This way, we sustain while improving incrementally.
                        </p>

                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="agile_title my-auto offset-xl-1">
                        <div className="content_pointer">
                            <div className="pointers_item">
                                <div className="title_count">17+<span>projects completed</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">13+<span>businesses served</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">6+<span>industries covered</span></div>
                            </div>
                        </div>
                        <LazyLoadImage
                            src={Pro01}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Agile;